// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
// Heavily inspired by https://www.npmjs.com/package/@azure/communication-react
import React from "react";
import SendIcon from "@mui/icons-material/Send";
import { IconButton, TextField } from "@mui/material";
import aderantTheme from "../../../Theme/AderantTheme";
export const EMPTY_MESSAGE_REGEX = /^\s*$/;
export const sanitizeText = (message) => {
    if (EMPTY_MESSAGE_REGEX.test(message)) {
        return "";
    }
    else {
        return message.trim();
    }
};
export const AddBoxComponent = (props) => {
    const { id, textValue, onChange, placeholderText, onKeyDown, sendMessage, disabled, sx, inputRef } = props;
    const renderTextField = () => {
        const textFieldProps = {
            autoFocus: props.autoFocus === "sendBoxTextField",
            multiline: true,
            id,
            placeholder: placeholderText,
            autoComplete: "off",
            disabled
        };
        const defaultInputSx = {
            "&": { width: "100%" },
            "& .MuiInputBase-input": { padding: "6px 8px" },
            "& .MuiInputBase-root.MuiOutlinedInput-root": { padding: "3px", backgroundColor: aderantTheme.palette.background.default }
        };
        const combinedInputSx = sx?.input ? { ...defaultInputSx, ...sx.input } : defaultInputSx;
        return (React.createElement(TextField, { ...textFieldProps, "aria-label": "SendBox", role: "textbox", sx: combinedInputSx, inputRef: inputRef, value: textValue, onChange: onChange, onKeyDown: (ev) => onKeyDown(ev), InputProps: {
                inputProps: { "aria-label": "SendBox Input Field" },
                endAdornment: (React.createElement(IconButton, { "aria-label": "SendBox Send Button", onClick: () => {
                        sendMessage();
                    }, disabled: disabled || sanitizeText(textValue) === "", sx: sx?.button }, sanitizeText(textValue) === "" ? React.createElement(SendIcon, { fontSize: "small" }) : React.createElement(SendIcon, { color: "primary", fontSize: "small" })))
            } }));
    };
    return renderTextField();
};
